import EventRepository from '../../model/EventRepository'
import {
  required
} from 'vuelidate/lib/validators'
import greaterOrEqualTo from '../../validators/greaterOrEqualTo'
import noMatchinOccurrences from '../../validators/noMatchinOccurrences'
import EventForm from '../EditEvent/EventForm.vue'

export default {
  name: 'AddEventView',

  data () {
    return {
      loading: false,

      regions: [],
      types: [],
      eventCodeOccurrences: [],

      event: {
        eventCode: '',
        name: '',
        regionId: null,
        startDate: null,
        endDate: null,
        type: null,
        notes: null,
        discountedProducts: []
      }
    }
  },

  computed: {
    regionOptions () {
      return this.regions.map(region => {
        return {
          text: region.name,
          value: region.storeRegionID
        }
      })
    }
  },

  validations: {
    event: {
      name: {
        required
      },
      eventCode: {
        required,
        unique: noMatchinOccurrences('eventCodeOccurrences', (value, parentVm) => {
          return {
            regionId: parentVm.regionId,
            eventCode: value.toLowerCase(),
            type: parentVm.type
          }
        })
      },
      startDate: {
        required
      },
      endDate: {
        required,
        greater: greaterOrEqualTo('startDate')
      },
      regionId: {
        required
      },
      type: {
        required
      }
    }
  },

  components: {
    'event-form': EventForm
  },

  methods: {
    load () {
      this.loading = true
      this.types = this.eventRepository.getTypes()

      this.eventRepository.getStoreRegions()
        .then(regions => {
          this.regions = regions
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$reportError(error)
        })
    },

    save () {
      this.loading = true

      this.eventRepository.getEventCodeOccurrences()
        .then(eventCodeOccurrences => {
          this.eventCodeOccurrences = eventCodeOccurrences
        })
        .then(() => {
          if (this.$v.$invalid) {
            this.$v.$touch()
            this.loading = false
            return
          }

          this.eventRepository.createEvent(this.event)
            .then(event => {
              this.$router.push('edit-event/' + event.id)
            })
            .catch(error => {
              this.loading = false
              this.$reportError(error)
            })
        })
    }
  },

  created () {
    this.eventRepository = new EventRepository(this.$api)
    this.load()
  }
}



// WEBPACK FOOTER //
// ./src/views/AddEvent/AddEvent.js